import React, { useState, useRef, useEffect, useCallback } from "react";
import gsap from "gsap";
import { NewsStyle } from "../styles/news.style";
import { StyledButton } from "../styles/button.style";
import useMediaQuery from "../hooks/useMediaQuery";
import classNames from "classnames";

const News = () => {
  const newsletter =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627801/mad_wallet/images/news/mdw-newsletter.png";
  const featuresHead =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627796/mad_wallet/images/features/mdw__features-head.png";
  const newsBg =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1650286770/mad_wallet/images/news/mdw__newsletterbg.jpg";
  const button =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627792/mad_wallet/images/buttons/mdw-btn.png";
  const buttonClicked =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627791/mad_wallet/images/buttons/mdw__btn-clicked.png";
  const featuresHeadmb =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1651182997/mad_wallet/images/mobile/Panels/headline-panel.png";

  const [buttonClick, setButtonClick] = useState(false);
  const [activeSlide, setActiveSlide] = useState(1);
  const rocketMan = useRef(null);
  const rocketMan1 = useRef(null);
  const rocketMan2 = useRef(null);
  const rocketMan3 = useRef(null);
  const newsRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      let x = e.touches ? e.touches[0].clientX : e.clientX;

      let y = e.touches ? e.touches[0].clientY : e.clientY;

      if (activeSlide === 1) {
        rocketMan.current = rocketMan1.current;
      } else if (activeSlide === 2) {
        rocketMan.current = rocketMan2.current;
      } else {
        rocketMan.current = rocketMan3.current;
      }

      let left = rocketMan.current.offsetLeft / 8;
      let top = rocketMan.current.offsetTop / 10;

      let offsetLeft = -(x - left) / left;
      let offsetTop = -(y - top) / top;

      gsap.to(rocketMan.current, {
        duration: 1,
        y: `${offsetTop}%`,
        x: `${offsetLeft}%`,
      });
    };

    newsRef.current.addEventListener("mousemove", handleMouseMove);
    newsRef.current.addEventListener("touchstart", handleMouseMove);
    newsRef.current.addEventListener("touchmove", handleMouseMove);
  }, [activeSlide]);

  const matches = useMediaQuery("(max-width: 768px)");

  const moveSlide = useCallback(() => {
    if (activeSlide === 2) {
      setActiveSlide(1);
    } else {
      setActiveSlide(activeSlide + 1);
    }
  }, [activeSlide]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      moveSlide();
    }, 6000);
    return () => {
      clearInterval(intervalId);
    };
  }, [moveSlide]);

  return (
    <NewsStyle id="newsletter" bg={newsBg} ref={newsRef}>
      <div
        className={classNames("newsSlide slide1", {
          active: activeSlide === 1,
        })}
      >
        <div className="newsletter__content">
          <div className="newsletter-message">
            <img
              src={matches ? featuresHeadmb : featuresHead}
              alt="subscribe to news"
            />
            <p className="newsletter__content--text">
              The MAD Wallet extension. The MAD Wallet extension is the first
              experience into the Madverse. Sit back and let’s take you on a
              journey{" "}
            </p>
          </div>
        </div>
        <div className="newsletter__interactive">
          <StyledButton
            bg={buttonClick ? buttonClicked : button}
            onClick={() => setButtonClick(true)}
          >
            <span>Download extension</span>
          </StyledButton>
          <h4 className="platforms">supported platforms</h4>
        </div>
        <div className="newsletter-img" ref={rocketMan1}>
          <img src={newsletter} alt="please subscribe" />
        </div>
      </div>

      <div
        className={classNames("newsSlide slide2", {
          active: activeSlide === 2,
        })}
      >
        <div className="newsletter__content">
          <div className="newsletter-message">
            <img
              src={matches ? featuresHeadmb : featuresHead}
              alt="subscribe to news"
            />
            <p className="newsletter__content--text">
              <span>MAD Wallet Themes:</span> Enjoy our library of amazing themes! In the
              future, You can even create your own themes and sell them on the
              Marketplace.
            </p>
          </div>
        </div>
        <div className="newsletter__interactive">
          <StyledButton
            bg={buttonClick ? buttonClicked : button}
            onClick={() => setButtonClick(true)}
          >
            <span>Download extension</span>
          </StyledButton>
          <h4 className="platforms">supported platforms</h4>
        </div>
        <div className="newsletter-img" ref={rocketMan2}>
          <img src={newsletter} alt="please subscribe" />
        </div>
      </div>
      <div className="holes">
        {[1, 2].map((v, idx) => (
          <div
            key={idx}
            onClick={() => setActiveSlide(idx + 1)}
            className={classNames({ active: activeSlide === idx + 1 })}
          ></div>
        ))}
      </div>
    </NewsStyle>
  );
};

export default News;
